import React, {BaseSyntheticEvent, FC, useCallback, useRef, useEffect, useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { Fonts, useToasts } from '@brg/ui';

import { CustomInputProps } from '../../components/inputs/components/dropdown/Dropdown';
import { LayoutConst } from "../../../core";

//при стандартном значение lineHeight режутся некоторые буквы
const ADDITIONAL_HEIGHT_PART = 3;

const ProjectTitleTextarea = styled.textarea<CustomInputProps & { isProjectEdit?: boolean }>`
  ${Fonts.Inter.justInCase};
  font-weight: 500;
  color: ${(p) => p.theme.projectView.titleColor};
  outline: none !important;
  font-size: 30px;
  line-height: 33px;
  background-color: transparent;
  width: 100%;
  border: none !important;
  resize: none;
  overflow: hidden;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding-left: 0;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`
  @media(max-width: 834px) {
    font-weight: 600;
    font-size: 22px;
    line-height: 25px;
  }
  ` : null};
`;

type PropsT = {
  title: string;
  id?: string;
  customProps?: CustomInputProps;
  onTitleChange: (title: string) => void;
  isProjectEdit?: boolean;
  isCollectionVote?: boolean;
  disabled?: boolean;
};

const MAX_TITLE_LENGTH = 75;
const MAX_COLLECTION_VOTE_LENGTH = 35;

const onDrop = (e: BaseSyntheticEvent) => {
  e.preventDefault();
};

const autoResize = (area: HTMLTextAreaElement) => {
  const lineHeight = window.getComputedStyle(area as HTMLElement, null).getPropertyValue('line-height');
  area.style.height = 'auto';
  area.rows = 1
  const secondLine = area.scrollHeight >= (parseInt(lineHeight) * 2);

  if (secondLine) {
    area.rows = 2
    area.style.height = area.scrollHeight + 'px';
  } else {
    area.style.height = `${parseInt(lineHeight) + ADDITIONAL_HEIGHT_PART}px`;
  }
};

const ProjectTitleEditable: FC<PropsT> = ({ title, customProps, id, onTitleChange, isProjectEdit, isCollectionVote, disabled }) => {
  const { t } = useTranslation();
  const toasts = useToasts();

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const MAX_LENGTH = useMemo(() => isCollectionVote ? MAX_COLLECTION_VOTE_LENGTH : MAX_TITLE_LENGTH, [isCollectionVote, MAX_COLLECTION_VOTE_LENGTH, MAX_TITLE_LENGTH])

  const showError = useCallback(() => {
    toasts.error(t('project_edit.max_title_length_error', { length: MAX_LENGTH }));
  }, [toasts, t, MAX_LENGTH]);

  // @ts-ignore
  const onChange = useCallback((e) => {
    const target = e.target as HTMLTextAreaElement;
    let value = target.value

    if (value.length >= MAX_LENGTH) {
      showError();
      value.slice(0, MAX_LENGTH)
    }

    onTitleChange(value);
    autoResize(target);
  }, [onTitleChange, MAX_LENGTH]);

  useEffect(() => {
    if (textareaRef.current && !!textareaRef.current.scrollHeight) {
      const handler = () => {
        if (textareaRef.current) {
          autoResize(textareaRef.current);
        }
      };

      handler();

      window.addEventListener('resize', handler);

      return () => {
        window.removeEventListener('resize', handler);
      };
    }
  }, [
    textareaRef, 
    textareaRef.current, 
    title, 
    textareaRef.current?.scrollHeight
  ]);

  return (
    <ProjectTitleTextarea
      {...(customProps || {})}
      ref={textareaRef}
      rows={1}
      maxLength={MAX_LENGTH}
      onChange={onChange}
      value={title}
      onDrop={onDrop}
      disabled={disabled}
      isProjectEdit={isProjectEdit}
    />
  );
};

export default ProjectTitleEditable;
import React, {BaseSyntheticEvent, FC, useCallback, useRef, useEffect, useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { Fonts, useToasts } from '@brg/ui';

import { CustomInputProps } from '../../components/inputs/components/dropdown/Dropdown';
import { LayoutConst } from "../../../core";

//при стандартном значение lineHeight режутся некоторые буквы
const ADDITIONAL_HEIGHT_PART = 3;

const ProjectTitleTextarea = styled.textarea<CustomInputProps & { isProjectEdit?: boolean }>`
  ${Fonts.Inter.justInCase};
  font-weight: 500;
  color: ${(p) => p.theme.projectView.titleColor};
  outline: none !important;
  font-size: 30px;
  line-height: 33px;
  background-color: transparent;
  width: 100%;
  border: none !important;
  resize: none;
  overflow: hidden;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding-left: 0;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`
  @media(max-width: 834px) {
    font-weight: 600;
    font-size: 22px;
    line-height: 25px;
  }
  ` : null};
`;

type PropsT = {
  title: string;
  id?: string;
  customProps?: CustomInputProps;
  onTitleChange: (title: string) => void;
  isProjectEdit?: boolean;
  isCollectionVote?: boolean;
  disabled?: boolean;
};

const MAX_TITLE_LENGTH = 75;
const MAX_COLLECTION_VOTE_LENGTH = 35;

const onDrop = (e: BaseSyntheticEvent) => {
  e.preventDefault();
};

const autoResize = (area: HTMLTextAreaElement) => {
  const lineHeight = window.getComputedStyle(area as HTMLElement, null).getPropertyValue('line-height');
  area.style.height = 'auto';
  area.rows = 1
  const secondLine = area.scrollHeight >= (parseInt(lineHeight) * 2);

  if (secondLine) {
    area.rows = 2
    area.style.height = area.scrollHeight + 'px';
  } else {
    area.style.height = `${parseInt(lineHeight) + ADDITIONAL_HEIGHT_PART}px`;
  }
};

const ProjectTitleEditable: FC<PropsT> = ({ title, customProps, id, onTitleChange, isProjectEdit, isCollectionVote, disabled }) => {
  const { t } = useTranslation();
  const toasts = useToasts();

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const MAX_LENGTH = useMemo(() => isCollectionVote ? MAX_COLLECTION_VOTE_LENGTH : MAX_TITLE_LENGTH, [isCollectionVote, MAX_COLLECTION_VOTE_LENGTH, MAX_TITLE_LENGTH])

  const showError = useCallback(() => {
    toasts.error(t('project_edit.max_title_length_error', { length: MAX_LENGTH }));
  }, [toasts, t, MAX_LENGTH]);

  // @ts-ignore
  const onChange = useCallback((e) => {
    const target = e.target as HTMLTextAreaElement;
    let value = target.value

    if (value.length >= MAX_LENGTH) {
      showError();
      value.slice(0, MAX_LENGTH)
    }

    onTitleChange(value);
    autoResize(target);
  }, [onTitleChange, MAX_LENGTH]);

  useEffect(() => {
    if (textareaRef.current && !!textareaRef.current.scrollHeight) {
      const handler = () => {
        if (textareaRef.current) {
          autoResize(textareaRef.current);
        }
      };

      handler();

      window.addEventListener('resize', handler);

      return () => {
        window.removeEventListener('resize', handler);
      };
    }
  }, [
    textareaRef, 
    textareaRef.current, 
    title, 
    textareaRef.current?.scrollHeight
  ]);

  return (
    <ProjectTitleTextarea
      {...(customProps || {})}
      ref={textareaRef}
      rows={1}
      maxLength={MAX_LENGTH}
      onChange={onChange}
      value={title}
      onDrop={onDrop}
      disabled={disabled}
      isProjectEdit={isProjectEdit}
    />
  );
};

export default ProjectTitleEditable;
